import React, { useState } from 'react';
import { Phone, X, Loader2 } from 'lucide-react';
import client from '../lib/api';
import { useToast } from '../hooks/use-toast';

const CallbackModal = ({ open, onClose }) => {
  const [form, setForm] = useState({ name: '', phone: '', subject: '', note: '' });
  const [busy, setBusy] = useState(false);
  const { toast } = useToast();

  if (!open) return null;
  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast({ title: 'Ad ve telefon zorunlu' }); return; }
    setBusy(true);
    try { await client.post('/callback', form); toast({ title: 'Talebiniz alındı', description: 'Kısa süre içinde sizi arayacağız' }); onClose(); }
    catch (e) { toast({ title: 'Hata', description: e.response?.data?.detail }); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(6px)' }} />
      <div className="responsive-dialog relative w-full max-w-md pusu-panel overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 side-icon-btn inline-flex" style={{ width: 36, height: 36 }}><X size={16} /></button>
        <div className="p-6">
          <div className="flex items-center gap-2 mb-1">
            <Phone size={18} className="text-[var(--pusu-gold)]" />
            <h2 className="text-xl font-black gold-text">Beni Ara</h2>
          </div>
          <p className="text-sm text-gray-400 mb-5">Adınızı ve telefonunuzu bırakın, sizi arayalım.</p>
          <form onSubmit={submit} className="space-y-3">
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Ad Soyad" className="pusu-input" />
            <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Telefon (5xxxxxxxxx)" className="pusu-input" />
            <input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} placeholder="Konu (opsiyonel)" className="pusu-input" />
            <textarea value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} placeholder="Mesajınız (opsiyonel)" className="pusu-input" style={{ minHeight: 80, padding: 12 }} />
            <button type="submit" disabled={busy} className="gold-btn w-full py-3 rounded-xl flex items-center justify-center gap-2">{busy && <Loader2 size={14} className="animate-spin" />} Talebi Gönder</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CallbackModal;
